import { render } from "./municipios.vue?vue&type=template&id=218b7e17&scoped=true"
import script from "./municipios.vue?vue&type=script&lang=js"
export * from "./municipios.vue?vue&type=script&lang=js"

import "./municipios.vue?vue&type=style&index=0&id=218b7e17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218b7e17"]])

export default __exports__